module.exports = __webpack_public_path__ + "img/banner.084b8099.png";